<template>
  <div>
    <div class="tournament-bracket">
      <h1 v-if="lowerTree">{{ $t("upper-bracket") }}</h1>
      <div class="wrapper">
        <BracketItem :children="upperTree" />
      </div>
    </div>

    <div class="tournament-bracket" v-if="lowerTree">
      <div class="wrapper">
        <h1>{{ $t("lower-bracket") }}</h1>
        <BracketItem :children="lowerTree" />
      </div>
    </div>
  </div>
</template>

<script>
import BracketItem from "@/components/bracket/BracketItem.vue";

export default {
  components: { BracketItem },
  props: ["teams", "games"],
  computed: {
    upperTree() {
      let sortedGames = this.upperBracketGames.sort((g1, g2) => g1.round - g2.round);

      switch (this.teams.length) {
        case 4:
          return this.teams4Tree(sortedGames);
        case 8:
          return this.teams8Tree(sortedGames);
        case 16:
          return this.teams16Tree(sortedGames);
        default:
          return [];
      }
    },
    lowerTree() {
      if (!this.lowerBracketGames.length) return;

      const sortedGames = this.lowerBracketGames.sort((g1, g2) => g1.round - g2.round);

      switch (this.teams.length) {
        case 4:
          return this.teams4TreeLower(sortedGames);
        case 8:
          return this.teams8TreeLower(sortedGames);
        case 16:
          return this.teams16TreeLower(sortedGames);
        default:
          return [];
      }
    },
    upperBracketGames() {
      return this.games.filter(g => !g.losers_bracket);
    },
    lowerBracketGames() {
      return this.games.filter(g => g.losers_bracket);
    },
  },
  methods: {
    findWinnerNameByGame(game) {
      if (!game) return "TBD";
      const { home_name, home_score, visitor_name, visitor_score } = game;
      if (home_score === null && visitor_score === null) return "TBD";
      return home_score > visitor_score ? home_name : visitor_name;
    },
    findWinnerNameByPreviousWinners(games, winner1, winner2) {
      const game = games.find(
        g =>
          (g.home_name === winner1 && g.visitor_name === winner2) ||
          (g.home_name === winner2 && g.visitor_name === winner1),
      );

      if (!game) return "TBD";
      const { home_name, home_score, visitor_name, visitor_score } = game;
      if (home_score === null && visitor_score === null) return "TBD";
      return home_score > visitor_score ? home_name : visitor_name;
    },
    findScoreByWinners(games, winner1, winner2) {
      const game = games.find(
        g =>
          (g.home_name === winner1 && g.visitor_name === winner2) ||
          (g.home_name === winner2 && g.visitor_name === winner1),
      );

      if (!game) return;
      const { home_name, home_score, visitor_score } = game;
      return home_name === winner1 ? home_score : visitor_score;
    },
    teams4Tree(games) {
      const winner0 = this.findWinnerNameByGame(games[0]);
      const winner1 = this.findWinnerNameByGame(games[1]);
      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, winner1);

      return [
        {
          name: winner0_1,
          children: [
            {
              name: winner0,
              score: this.findScoreByWinners(games, winner0, winner1),
              children: [
                { name: games[0].home_name, score: games[0].home_score },
                { name: games[0].visitor_name, score: games[0].visitor_score },
              ],
            },
            {
              name: winner1,
              score: this.findScoreByWinners(games, winner1, winner0),
              children: [
                { name: games[1].home_name, score: games[1].home_score },
                { name: games[1].visitor_name, score: games[1].visitor_score },
              ],
            },
          ],
        },
      ];
    },
    teams4TreeLower(games) {
      const winner0 = this.findWinnerNameByGame(games[0]);
      let additionalTeam = "TBD";
      let additionalScore = "";

      if (games[1]) {
        additionalTeam = games[1].home_name === winner0 ? games[1].visitor_name : games[1].home_name;
        additionalScore = games[1].home_name === winner0 ? games[1].visitor_score : games[1].home_score;
      }

      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, additionalTeam);

      return [
        {
          name: winner0_1,
          children: [
            { name: additionalTeam, score: additionalScore },
            {
              name: winner0,
              score: this.findScoreByWinners(games, winner0, additionalTeam),
              children: [
                { name: games[0].home_name, score: games[0].home_score },
                { name: games[0].visitor_name, score: games[0].visitor_score },
              ],
            },
          ],
        },
      ];
    },
    teams8Tree(games) {
      const winner0 = this.findWinnerNameByGame(games[0]);
      const winner1 = this.findWinnerNameByGame(games[1]);
      const winner2 = this.findWinnerNameByGame(games[2]);
      const winner3 = this.findWinnerNameByGame(games[3]);
      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, winner1);
      const winner2_3 = this.findWinnerNameByPreviousWinners(games, winner2, winner3);
      const finalWinner = this.findWinnerNameByPreviousWinners(games, winner0_1, winner2_3);

      return [
        {
          name: finalWinner,
          children: [
            {
              name: winner0_1,
              score: this.findScoreByWinners(games, winner0_1, winner2_3),
              children: [
                {
                  name: winner0,
                  score: this.findScoreByWinners(games, winner0, winner1),
                  children: [
                    { name: games[0].home_name, score: games[0].home_score },
                    { name: games[0].visitor_name, score: games[0].visitor_score },
                  ],
                },
                {
                  name: winner1,
                  score: this.findScoreByWinners(games, winner1, winner0),
                  children: [
                    { name: games[1].home_name, score: games[1].home_score },
                    { name: games[1].visitor_name, score: games[1].visitor_score },
                  ],
                },
              ],
            },
            {
              name: winner2_3,
              score: this.findScoreByWinners(games, winner2_3, winner0_1),
              children: [
                {
                  name: winner2,
                  score: this.findScoreByWinners(games, winner2, winner3),
                  children: [
                    { name: games[2].home_name, score: games[2].home_score },
                    { name: games[2].visitor_name, score: games[2].visitor_score },
                  ],
                },
                {
                  name: winner3,
                  score: this.findScoreByWinners(games, winner3, winner2),
                  children: [
                    { name: games[3].home_name, score: games[3].home_score },
                    { name: games[3].visitor_name, score: games[3].visitor_score },
                  ],
                },
              ],
            },
          ],
        },
      ];
    },
    teams8TreeLower(games) {
      const games2Round = games.filter(g => g.round === 2);
      const games3Round = games.filter(g => g.round === 3);
      const games4Round = games.filter(g => g.round === 4);
      const games5Round = games.filter(g => g.round === 5);

      const additional3RoundGame = games3Round.filter(g => {
        return !games2Round.find(game => game.home_name === g.home_name || game.visitor_name === g.home_name);
      })[0];
      const additional5RoundGame = games5Round.filter(g => {
        return !games4Round.find(game => game.home_name === g.home_name || game.visitor_name === g.home_name);
      })[0];

      const winner0 = this.findWinnerNameByGame(games[0]);
      const winner1 = this.findWinnerNameByGame(games[1]);
      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, winner1);
      const aWinner = this.findWinnerNameByGame(additional3RoundGame);
      const aWinner01 = this.findWinnerNameByPreviousWinners(games, aWinner, winner0_1);

      let additionalFinalTeam = "TBD";
      let additionalFinalScore = "";

      if (additional5RoundGame) {
        additionalFinalTeam =
          additional5RoundGame.home_name === aWinner01
            ? additional5RoundGame.visitor_name
            : additional5RoundGame.home_name;

        additionalFinalScore =
          additional5RoundGame.home_name === aWinner01
            ? additional5RoundGame.visitor_score
            : additional5RoundGame.home_score;
      }

      const finalWinner = this.findWinnerNameByPreviousWinners(games, additionalFinalTeam, aWinner01);

      return [
        {
          name: finalWinner,
          children: [
            { name: additionalFinalTeam, score: additionalFinalScore },
            {
              name: aWinner01,
              score: this.findScoreByWinners(games, aWinner01, additionalFinalTeam),
              children: [
                {
                  name: aWinner,
                  score: this.findScoreByWinners(games, aWinner, winner0_1),
                  children: [
                    {
                      name: additional3RoundGame ? additional3RoundGame.home_name : "TBD",
                      score: additional3RoundGame && additional3RoundGame.home_score,
                    },
                    {
                      name: additional3RoundGame ? additional3RoundGame.visitor_name : "TDB",
                      score: additional3RoundGame && additional3RoundGame.visitor_score,
                    },
                  ],
                },
                {
                  name: winner0_1,
                  score: this.findScoreByWinners(games, winner0_1, aWinner),
                  children: [
                    {
                      name: winner0,
                      score: this.findScoreByWinners(games, winner0, winner1),
                      children: [
                        { name: games[0].home_name, score: games[0].home_score },
                        { name: games[0].visitor_name, score: games[0].visitor_score },
                      ],
                    },
                    {
                      name: winner1,
                      score: this.findScoreByWinners(games, winner1, winner0),
                      children: [
                        { name: games[1].home_name, score: games[1].home_score },
                        { name: games[1].visitor_name, score: games[1].visitor_score },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];
    },
    teams16Tree(games) {
      const winner0 = this.findWinnerNameByGame(games[0]);
      const winner1 = this.findWinnerNameByGame(games[1]);
      const winner2 = this.findWinnerNameByGame(games[2]);
      const winner3 = this.findWinnerNameByGame(games[3]);
      const winner4 = this.findWinnerNameByGame(games[4]);
      const winner5 = this.findWinnerNameByGame(games[5]);
      const winner6 = this.findWinnerNameByGame(games[6]);
      const winner7 = this.findWinnerNameByGame(games[7]);
      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, winner1);
      const winner2_3 = this.findWinnerNameByPreviousWinners(games, winner2, winner3);
      const winner4_5 = this.findWinnerNameByPreviousWinners(games, winner4, winner5);
      const winner6_7 = this.findWinnerNameByPreviousWinners(games, winner6, winner7);
      const winner01_23 = this.findWinnerNameByPreviousWinners(games, winner0_1, winner2_3);
      const winner45_67 = this.findWinnerNameByPreviousWinners(games, winner4_5, winner6_7);

      return [
        {
          name: this.findWinnerNameByPreviousWinners(games, winner01_23, winner45_67),
          children: [
            {
              name: winner01_23,
              score: this.findScoreByWinners(games, winner01_23, winner45_67),
              children: [
                {
                  name: winner0_1,
                  score: this.findScoreByWinners(games, winner0_1, winner2_3),
                  children: [
                    {
                      name: winner0,
                      score: this.findScoreByWinners(games, winner0, winner1),
                      children: [
                        { name: games[0].home_name, score: games[0].home_score },
                        { name: games[0].visitor_name, score: games[0].visitor_score },
                      ],
                    },
                    {
                      name: winner1,
                      score: this.findScoreByWinners(games, winner1, winner0),
                      children: [
                        { name: games[1].home_name, score: games[1].home_score },
                        { name: games[1].visitor_name, score: games[1].visitor_score },
                      ],
                    },
                  ],
                },
                {
                  name: winner2_3,
                  score: this.findScoreByWinners(games, winner2_3, winner0_1),
                  children: [
                    {
                      name: winner2,
                      score: this.findScoreByWinners(games, winner2, winner3),
                      children: [
                        { name: games[2].home_name, score: games[2].home_score },
                        { name: games[2].visitor_name, score: games[2].visitor_score },
                      ],
                    },
                    {
                      name: winner3,
                      score: this.findScoreByWinners(games, winner3, winner2),
                      children: [
                        { name: games[3].home_name, score: games[3].home_score },
                        { name: games[3].visitor_name, score: games[3].visitor_score },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: winner45_67,
              score: this.findScoreByWinners(games, winner45_67, winner01_23),
              children: [
                {
                  name: winner4_5,
                  score: this.findScoreByWinners(games, winner4_5, winner6_7),
                  children: [
                    {
                      name: winner4,
                      score: this.findScoreByWinners(games, winner4, winner5),
                      children: [
                        { name: games[4].home_name, score: games[4].home_score },
                        { name: games[4].visitor_name, score: games[4].visitor_score },
                      ],
                    },
                    {
                      name: winner5,
                      score: this.findScoreByWinners(games, winner5, winner4),
                      children: [
                        { name: games[5].home_name, score: games[5].home_score },
                        { name: games[5].visitor_name, score: games[5].visitor_score },
                      ],
                    },
                  ],
                },
                {
                  name: winner6_7,
                  score: this.findScoreByWinners(games, winner6_7, winner4_5),
                  children: [
                    {
                      name: winner6,
                      score: this.findScoreByWinners(games, winner6, winner7),
                      children: [
                        { name: games[6].home_name, score: games[6].home_score },
                        { name: games[6].visitor_name, score: games[6].visitor_score },
                      ],
                    },
                    {
                      name: winner7,
                      score: this.findScoreByWinners(games, winner7, winner6),
                      children: [
                        { name: games[7].home_name, score: games[7].home_score },
                        { name: games[7].visitor_name, score: games[7].visitor_score },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];
    },
    teams16TreeLower(games) {
      const games2Round = games.filter(g => g.round === 2);
      const games3Round = games.filter(g => g.round === 3);
      const games4Round = games.filter(g => g.round === 4);
      const games5Round = games.filter(g => g.round === 5);

      const additional3RoundGames = games3Round.filter(g => {
        return !games2Round.find(game => game.home_name === g.home_name || game.visitor_name === g.home_name);
      });
      const additional4RoundGames = games4Round.filter(g => {
        return !games3Round.find(game => game.home_name === g.home_name || game.visitor_name === g.home_name);
      });
      const additional5RoundGames = games5Round.filter(g => {
        return !games4Round.find(game => game.home_name === g.home_name || game.visitor_name === g.home_name);
      });

      const winner0 = this.findWinnerNameByGame(games[0]);
      const winner1 = this.findWinnerNameByGame(games[1]);
      const winner2 = this.findWinnerNameByGame(games[2]);
      const winner3 = this.findWinnerNameByGame(games[3]);
      const winner0_1 = this.findWinnerNameByPreviousWinners(games, winner0, winner1);
      const winner2_3 = this.findWinnerNameByPreviousWinners(games, winner2, winner3);
      const a3Winner0 = this.findWinnerNameByGame(additional3RoundGames[0]);
      const a3Winner1 = this.findWinnerNameByGame(additional3RoundGames[1]);
      const a3Winner0_01 = this.findWinnerNameByPreviousWinners(games, a3Winner0, winner0_1);
      const a3Winner1_23 = this.findWinnerNameByPreviousWinners(games, a3Winner1, winner2_3);
      const a4Winner0 = this.findWinnerNameByGame(additional4RoundGames[0]);
      const a5Winner1 = this.findWinnerNameByPreviousWinners(games, a4Winner0, a3Winner0_01);

      let a5Team = "TBD";

      if (additional5RoundGames[0] && a3Winner1_23 !== "TBD") {
        a5Team =
          additional5RoundGames[0].home_name === a3Winner1_23
            ? additional5RoundGames[0].visitor_name
            : additional5RoundGames[0].home_name;
      }

      const a5Winner2 = this.findWinnerNameByPreviousWinners(games, a3Winner1_23, a5Team);
      const finalWinner = this.findWinnerNameByPreviousWinners(games, a5Winner1, a5Winner2);

      return [
        {
          name: finalWinner,
          children: [
            {
              name: a5Winner1,
              score: this.findScoreByWinners(games, a5Winner1, a5Winner2),
              children: [
                {
                  name: a4Winner0,
                  score: this.findScoreByWinners(games, a4Winner0, a3Winner0_01),
                  children: [
                    {
                      name: additional4RoundGames[0] ? additional4RoundGames[0].home_name : "TBD",
                      score: additional4RoundGames[0] && additional4RoundGames[0].home_score,
                    },
                    {
                      name: additional4RoundGames[0] ? additional4RoundGames[0].visitor_name : "TBD",
                      score: additional4RoundGames[0] && additional4RoundGames[0].visitor_score,
                    },
                  ],
                },
                {
                  name: a3Winner0_01,
                  score: this.findScoreByWinners(games, a3Winner0_01, a4Winner0),
                  children: [
                    {
                      name: a3Winner0,
                      score: this.findScoreByWinners(games, a3Winner0, winner0_1),
                      children: [
                        {
                          name: additional3RoundGames[0] ? additional3RoundGames[0].home_name : "TBD",
                          score: additional3RoundGames[0] && additional3RoundGames[0].home_score,
                        },
                        {
                          name: additional3RoundGames[0] ? additional3RoundGames[0].visitor_name : "TBD",
                          score: additional3RoundGames[0] && additional3RoundGames[0].visitor_score,
                        },
                      ],
                    },
                    {
                      name: winner0_1,
                      score: this.findScoreByWinners(games, winner0_1, a3Winner0),
                      children: [
                        {
                          name: winner0,
                          score: this.findScoreByWinners(games, winner0, winner1),
                          children: [
                            { name: games[0].home_name, score: games[0].home_score },
                            { name: games[0].visitor_name, score: games[0].visitor_score },
                          ],
                        },
                        {
                          name: winner1,
                          score: this.findScoreByWinners(games, winner1, winner0),
                          children: [
                            { name: games[1].home_name, score: games[1].home_score },
                            { name: games[1].visitor_name, score: games[1].visitor_score },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: a5Winner2,
              score: this.findScoreByWinners(games, a5Winner2, a5Winner1),
              children: [
                {
                  name: a3Winner1_23,
                  score: this.findScoreByWinners(games, a3Winner1_23, a5Team),
                  children: [
                    {
                      name: winner2_3,
                      score: this.findScoreByWinners(games, winner2_3, a3Winner1),
                      children: [
                        {
                          name: winner2,
                          score: this.findScoreByWinners(games, winner2, winner3),
                          children: [
                            { name: games[2].home_name, score: games[2].home_score },
                            { name: games[2].visitor_name, score: games[2].visitor_score },
                          ],
                        },
                        {
                          name: winner3,
                          score: this.findScoreByWinners(games, winner3, winner2),
                          children: [
                            { name: games[3].home_name, score: games[3].home_score },
                            { name: games[3].visitor_name, score: games[3].visitor_score },
                          ],
                        },
                      ],
                    },
                    {
                      name: a3Winner1,
                      score: this.findScoreByWinners(games, a3Winner1, winner2_3),
                      children: [
                        {
                          name: additional3RoundGames[1] ? additional3RoundGames[1].home_name : "TBD",
                          score: additional3RoundGames[1] && additional3RoundGames[1].home_score,
                        },
                        {
                          name: additional3RoundGames[1] ? additional3RoundGames[1].visitor_name : "TBD",
                          score: additional3RoundGames[1] && additional3RoundGames[1].visitor_score,
                        },
                      ],
                    },
                  ],
                },
                { name: a5Team },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>
